<template>
  <div class="conclusion-list">
    <div
      v-for="item in items"
      :key="item.id">

      <div :class="`conclusion-list-item conclusion-list-item-date-${dateType(item)}`">
        <div class="conclusion-list-item-date">
          {{formatDate(item.dateFrom, 'd.m.y')}}
          {{item.dateTo ? ` - ${formatDate(item.dateTo, 'd.m.y')}` : ''}}
        </div>

        <div class="conclusion-list-item-title">
          {{item.title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../utils/formatDate';

export default {
  name: 'ConclusionList',

  props: ['items', 'type'],

  data() {
    return {};
  },

  methods: {
    formatDate(dateString, format) {
      return formatDate(new Date(dateString), format);
    },

    dateType(item) {
      if (this.type === 'conclusion') {
        return 'line';
      }

      if (item.dateTo) {
        return 'long';
      }

      return 'normal';
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";

.conclusion-list {
  .conclusion-list-item {
    position: relative;
    font-weight: normal;
    font-size: 14px;
    border-top: 1px solid $light-gray;

    .conclusion-list-item-date {
      position: absolute;
      right: 0;
      top: 12px;
      padding: 0 5px;
      font-size: 12px;
      color: $dark-gray;
      text-align: right;
    }

    .conclusion-list-item-title {
      padding: 10px 20px;
    }

    &.conclusion-list-item-date-line {
      .conclusion-list-item-date {
        position: relative;
        padding: 10px 20px;
        text-align: left;
      }
    }

    &.conclusion-list-item-date-normal {
      .conclusion-list-item-date {
        width: 80px;
      }

      .conclusion-list-item-title {
        padding: 10px 90px 10px 20px;
      }
    }

    &.conclusion-list-item-date-long {
      .conclusion-list-item-date {
        width: 150px;
      }

      .conclusion-list-item-title {
        padding: 10px 150px 10px 20px;
      }
    }
  }
}
</style>
